import React, { Component, PropTypes } from 'react';
import { Router, browserHistory } from 'react-router';
import {Link} from 'react-router';
import RecommendationComponent from './RecommendationComponent'
import QuestionComponent from './QuestionComponent'
import QuestionComponentDelegate from './QuestionComponent'
import LearnMoreComponent from './LearnMoreComponent'
import RecommendationAlgorithm from '../models/RecommendationAlgorithm'
import Answer from '../models/Answer'
import Question from '../models/Question'
import Recommendation from '../models/Recommendation'
import '../styles/navigation.scss';
var ReactCSSTransitionGroup = require('react-addons-css-transition-group');
import StringHelper from '../utils/stringHelper'
import * as constants from '../constants/constants'
import * as bleedingRisk from '../models/BleedingRisk'

class NavBar extends Component {
  constructor(props) {
    super(props);
  }
  onBackButtonEvent(event) {
  event.preventDefault();
    this.popComponent();
}
  componentDidMount(){
}
  componentDidUpdate(prevProps) {

  }

  delegate() {
    return this.props.delegate;
  }

  onBackButtonClick(event) {
    this.delegate().onNavBackButtonClick();
  }
  onInfoButtonClick(event) {
    this.delegate().onNavInfoButtonClick();
  }
  onResetButtonClick(event) {
    this.delegate().onNavResetButtonClick();
  }

  render() {
    return (
      <div className="navBar">
        <div className={"navBackButton"+(this.props.showBackButton ? "" : " hidden")} onClick={this.onBackButtonClick.bind(this)}>
        <img src={require("../images/ArrowWhite.png")} className="navBackButtonImage"/>
          <div className="navBackButtonText">Back</div>
          </div>
        <div className="navRightButtonContainer">
        <img src={require("../images/restartWhite.png")} className={"navInfoImage"+(this.props.showInfoButton ? "" : " hidden")} onClick={this.onResetButtonClick.bind(this)}/>
        <img src={require("../images/infoWhite.png")} className={"navInfoImage"+(this.props.showInfoButton ? "" : " hidden")} onClick={this.onInfoButtonClick.bind(this)}/>
          </div>
      </div>
    )
  }
}

export default NavBar;



/** WEBPACK FOOTER **
 ** ./src/components/NavBar.js
 **/